// src/redux/actions/jobTypeActions.js
import {
    FETCH_JOBTYPE_REQUEST,
    FETCH_JOBTYPE_SUCCESS,
    FETCH_JOBTYPE_FAILURE,
    SET_SELECTED_JOBTYPE,
  } from '../types';
  import axios from '../../API/axios';
  
  export const fetchJobType = () => async (dispatch) => {
    dispatch({ type: FETCH_JOBTYPE_REQUEST });
  
    try {
      const response = await axios.get(`/MasterData/GetJobTypesDDL`);
      let jobTypeList =response.data.responseData.map((val)=>{
        return{
          value:val.id,
          label:val.name,
        }
    })
      dispatch({
        type: FETCH_JOBTYPE_SUCCESS,
        payload: jobTypeList,
      });
    } catch (error) {
      dispatch({
        type: FETCH_JOBTYPE_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const selectJobType = (jobTypeId) => ({
    type: SET_SELECTED_JOBTYPE,
    payload: jobTypeId,
  });
  